<script setup lang="ts">
const { trackCta } = useCtaEvent()
</script>

<template>
  <v-container>
    <v-row>
      <v-sheet
        class="align-center text-center px-4 py-4"
        width="100%"
        height="auto"
        color="transparent"
      >
        <v-btn
          size="x-large"
          to="/signup"
          class="cta-button"
          @click="trackCta('冒険を始める（signup_now）')"
        >
          冒険を始める
          <span class="free-badge">無料</span>
        </v-btn>
      </v-sheet>
    </v-row>
    <v-row>
      <v-sheet
        class="align-center text-center my-2"
        width="100%"
        height="auto"
        color="transparent"
      >
        <v-btn
          variant="text"
          color="primary"
          height="auto"
          to="/signin"
        >
          登録済の方はサインイン
        </v-btn>
      </v-sheet>
    </v-row>
  </v-container>
</template>

<style scoped>
/* #737: CTA 形状・色を Hero(冒険を始める)のゴールドのピル型に統一 */
.cta-button {
  color: #1a1510 !important;
  background: linear-gradient(135deg, #d9a83e, #f0c96a) !important;
  border-radius: 999px !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  box-shadow: 0 8px 26px -8px rgba(216, 160, 60, 0.7);
}

/* #737: 無料バッジ（Hero と同一スタイル） */
.free-badge {
  display: inline-block;
  margin-left: 8px;
  font-size: 0.7em;
  font-weight: 800;
  color: #fff;
  background: #1a7566;
  border-radius: 999px;
  padding: 2px 10px;
  vertical-align: middle;
}

.glow-border-cycle {
  position: relative;
  overflow: hidden;
}

/* 光る境界 */
.glow-border-cycle::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 3px;
  border-radius: inherit;

  background: linear-gradient(
    90deg,
    transparent,
    /* rgba(200, 255, 100, 0.9), */
    #18FFFFE0,
    transparent
  );
  background-size: 200% 100%;

  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  -webkit-mask-composite: xor;

  pointer-events: none;

  animation: border-glow-cycle 3.5s linear infinite;
  opacity: 0;
}

/* 一周 → 消える → 待つ */
@keyframes border-glow-cycle {
  0% {
    background-position: 0% 50%;
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  40% {
    background-position: 200% 50%;
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    background-position: 200% 50%;
    opacity: 0;
  }
}
</style>
